import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import '@iframe-resizer/child';

// Filter out non-critical Twilio Insights telemetry errors
const originalConsoleError = console.error;
const originalConsoleWarn = console.warn;

const isTwilioInsightsError = (message) => {
  return (
    message.includes('[TwilioVoice][EventPublisher]') ||
    message.includes('Unable to post') ||
    message.includes('event to Insights') ||
    (message.includes('eventgw.us1.twilio.com') &&
      message.includes('ERR_CONNECTION_CLOSED')) ||
    (message.includes('eventgw.twilio.com') &&
      message.includes('ERR_CONNECTION_CLOSED')) ||
    (message.includes('POST https://eventgw') &&
      message.includes('ERR_CONNECTION_CLOSED'))
  );
};

console.error = (...args) => {
  const errorMessage = args.join(' ');
  // Only suppress Twilio Insights errors, log everything else
  if (!isTwilioInsightsError(errorMessage)) {
    originalConsoleError.apply(console, args);
  }
};

console.warn = (...args) => {
  const warnMessage = args.join(' ');
  // Suppress Twilio Insights warnings as well
  if (!isTwilioInsightsError(warnMessage)) {
    originalConsoleWarn.apply(console, args);
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
